/**
 * The three fields that tell two catalog items of one governed name apart, joined the way a
 * reader writes the product's name: `Lenovo ThinkPad X1 Gen 11`.
 *
 * **It is here rather than in the logistics slice because TWO suites draw it** — Stock Levels'
 * anchor and the purchase request's item picker — and a procurement component importing from
 * `features/logistics/…` would cross a feature slice to reach a four-line join. That is the
 * `stockStatusTone` call one layer out: a value more than one surface renders is defined once,
 * or the two drift and a reader meets one product written two ways on two screens.
 *
 * **Joined by a SPACE, not the product's ` — `.** That separator joins a qualifier to a name —
 * `College — University of the Philippines` — where these three are one product's name as
 * anybody writes it. Em dashes would read as separate facts.
 *
 * **THE NAME IS THE FALLBACK, never an em dash.** All three are optional, so a row can carry
 * any of them or none. An em dash is right for a cell stating an absent value and wrong for the
 * thing NAMING the record: on a table the anchor is the row's click target, and on a picker it
 * is the option's only label — a blank one is a row nobody can tell apart or choose.
 */
export function itemIdentity(parts: {
  manufacturer?: string | null;
  brandName?: string | null;
  model?: string | null;
}): string {
  return [parts.manufacturer, parts.brandName, parts.model].filter(Boolean).join(' ').trim();
}

/** The identity line where there is one, and the item's own name where there is not. */
export function itemIdentityOrName(
  parts: {
    manufacturer?: string | null;
    brandName?: string | null;
    model?: string | null;
  },
  name: string,
): string {
  return itemIdentity(parts) || name;
}
